import cookieStore from './provider/js-cookie';
import type { CookieAttributes } from 'js-cookie';

export default {
    get (key: string): string | undefined {
        return  cookieStore.get(key);
    },
    set (key: string, value: string, options: CookieAttributes = {}): void {
        cookieStore.set(key, value, options);
    },
    remove (key: string, options: CookieAttributes = {}): void {
        cookieStore.remove(key, options);
    }
}
